export const buildDateString = () => {
    let now = new Date();
    const month = now.getMonth() + 1;
    const day = now.getDate();

    return `${now.getFullYear()}_${month.toString().length === 1 ? `0${month}` : month}_${
        day.toString().length === 1 ? `0${day}` : day
    }`;
};
